import { DefaultProductOptions } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

export const getEditAddressBookAddressTag = (options: DefaultProductOptions) => {
  const level2 = 'Address the Envelope - Recipient';
  const modalEvent = [
    {
      eventInfo: {
        eventName: 'address book',
        eventAction: 'edit address',
      },
    },
  ];
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const { modal, user } = getModalTag(options.productType, level2, modalEvent, options.projectID);

  const newModal = {
    ...modal,
    messages: [{ statusMessages: '' }],
  };

  return {
    modal: newModal,
    product,
    user,
  };
};
